export default {
  contentModuleRow: {
    display: 'flex',
  },
  contentModuleCell: {
    width: '50%',
  },
  contentModuleCellPrice: {
    width: '50%',
    textAlign: 'right',
  }
}